import React from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import "./GateSummary.css";

const filters = [
  { value: "all", label: "All", count: "total", description: "All current gate accounts" },
  { value: "Invited", label: "Pending invitations", count: "pending", description: "Enabled invitations without current access" },
  { value: "Joined", label: "Joined", count: "joined", description: "Current access with recorded link enrollment" },
  { value: "Existing access", label: "Access without enrollment", count: "accessWithoutEnrollment", description: "Current access without recorded link enrollment" },
];

export default function GateSummary({ summary, loading, error, filter, onFilter, emails, disabled, copyNotice, onCopy }) {
  const unavailable = loading || !!error || !summary;
  return <section className="gate-summary" aria-label="Gate membership filters" aria-busy={loading}>
    <div className="gate-summary-toolbar">
      <div className="gate-summary-filters" role="group" aria-label="Filter gate accounts">
        {filters.map(({ value, label, count, description }) => <button
          key={value} type="button" aria-pressed={filter === value} title={description}
          disabled={disabled || unavailable} onClick={() => onFilter(value)}
        >{label} <span>{unavailable ? "—" : summary[count].toLocaleString()}</span></button>)}
      </div>
      <CopyToClipboard text={emails.join("\n")} onCopy={(_text, success) => onCopy(success)}>
        <button type="button" title="Copy unique, nonblank email addresses from shown accounts" disabled={disabled || unavailable || !emails.length}>Copy shown emails</button>
      </CopyToClipboard>
    </div>
    <p className="gate-summary-note" role={copyNotice ? "status" : undefined}>{loading ? "Loading accounts…" : error || !summary ? "Membership counts unavailable." : copyNotice || "Current gate accounts, not historical invitation lists."}</p>
  </section>;
}
